var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap wrap--mypage"
  }, [_c('main', {
    staticClass: "main",
    attrs: {
      "role": "main"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "mypage-title"
  }, [_c('h1', {
    staticClass: "text"
  }, [_vm._v("마이페이지")])]), _c('div', {
    staticClass: "mypage-container"
  }, [_c('mypage-navigation'), _c('div', {
    staticClass: "mypage-contents"
  }, [_c('v-data-table', _vm._b({
    staticClass: "v-data-table--default",
    attrs: {
      "hide-default-footer": "",
      "disable-filtering": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: "item.".concat(header.value),
        fn: function fn(_ref) {
          var value = _ref.value;
          return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
        }
      };
    }), {
      key: "item.state",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('v-chip', {
          staticClass: "w-80px w-md-100px w-lg-120px",
          attrs: {
            "x-small": "",
            "label": "",
            "dark": "",
            "color": _vm.stateColor(item)
          }
        }, [_vm._v(_vm._s(_vm.stateText(item)))])];
      }
    }, {
      key: "item.cancel",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('v-btn', {
          staticClass: "w-80px w-md-100px w-lg-120px",
          attrs: {
            "disabled": !_vm.isCancelable(item),
            "x-small": "",
            "color": "pink lighten-1"
          },
          on: {
            "click": function click($event) {
              return _vm.cancel(item);
            }
          }
        }, [_vm._v("신청취소")])];
      }
    }, {
      key: "footer",
      fn: function fn() {
        return [_c('pagination-component', {
          attrs: {
            "value": _vm.page,
            "count": _vm.pageCount
          },
          on: {
            "input": function input(page) {
              return _vm.$router.push({
                query: {
                  page: page
                }
              });
            }
          }
        })];
      },
      proxy: true
    }], null, true)
  }, 'v-data-table', {
    items: _vm.items,
    headers: _vm.headers
  }, false))], 1)], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }